module.exports = "/assets/data/8498193d7f1cd5072a48fa5de9e2d93a-B45.data.json";